export default {
  title: "Invoices",
  subtitle: "Manage invoices and billing",
  
  addNew: "Create New Invoice",
  createInvoice: "Create Invoice",
  editInvoice: "Edit Invoice",
  deleteInvoice: "Delete Invoice",
  PrintInvoice: "Print Invoice",
  fields: {
    invoiceNumber: "Invoice ID",
    orderNumber: "Order No",
    customer: "Customer",
    date: "Invoice Date",
    dueDate: "Due Date",
    status: "Status",
    subtotal: "Subtotal",
    tax: "Tax",
    total: "Total",
    notes: "Notes",
    items: "Items",
    createdAt: "Created At",
    updatedAt: "Updated At",
    collectionDate: "Collection Date",
    receivedDate: "Received Date",
    isCollected: "Is Collected",
    isReceived: "Is Received",
    amount: "Amount",
    orderId: "Order ID",
    shipForMeId: "Ship For Me ID",
    externalInvoiceNumber: "External Invoice Number",
    receivedInvoiceNumber: "Received Invoice Number",
    paymentGateway: "Payment Gateway",
    invoiceType: "Invoice Type",
    countryType: "Country Type",
    iqd: "IQD"
  },
  
  placeholders: {
    invoiceNumber: "Enter invoice number",
    customer: "Select customer",
    date: "Select invoice date",
    dueDate: "Select due date",
    notes: "Enter notes",
    collectionDate: "Select collection date",
    receivedDate: "Select received date",
    amount: "Enter amount",
    externalInvoiceNumber: "Enter external invoice number",
    receivedInvoiceNumber: "Enter received invoice number"
  },
  
  messages: {
    createSuccess: "Invoice created successfully",
    createError: "Failed to create invoice",
    updateSuccess: "Invoice updated successfully",
    updateError: "Failed to update invoice",
    deleteSuccess: "Invoice deleted successfully",
    deleteError: "Failed to delete invoice",
    deleteConfirm: "Are you sure you want to delete this invoice?",
    selectAtLeastOne: "Please select at least one invoice",
    enterInvoiceNumber: "Please enter an invoice number",
    bulkUpdateSuccess: "Invoices updated successfully",
    bulkUpdateError: "Failed to update invoices",
    noInvoices: "No invoices found",
    loadingInvoices: "Loading invoices...",
    fetchError: "Failed to fetch invoices"
  },

  // Additional fields
  receiveInvoices: "Receive Invoices",
  selectedForUpdate: "Selected {{count}} invoice(s) for update",
  updateSelected: "Update Selected",

  validation: {
    invoiceNumberRequired: "Invoice number is required",
    customerRequired: "Customer is required",
    dateRequired: "Invoice date is required",
    dueDateRequired: "Due date is required",
    itemsRequired: "At least one item is required"
  },
  
  table: {
    invoiceNumber: "Invoice #",
    customer: "Customer",
    date: "Date",
    dueDate: "Due Date",
    total: "Total",
    status: "Status",
    actions: "Actions"
  },
  
  statusOptions: {
    draft: "Draft",
    sent: "Sent",
    paid: "Paid",
    overdue: "Overdue",
    cancelled: "Cancelled"
  },

  invoiceTypeOptions: {
    in: "In",
    out: "Out"
  },

  // Print Invoice translations
  print: {
    companyLogo: "COMPANY LOGO",
    consignor: "Consignor:",
    consignee: "Consignee:",
    phone: "Phone:",
    date: "DATE:",
    invoiceNumber: "INVOICE #:",
    currency: "Currency:",
    paymentGateway: "Payment Gateway:",
    orderNumber: "Order #:",

    // Payment status stamps
    status: {
      paid: "PAID",
      unpaid: "UNPAID",
      cancelled: "CANCELLED",
      refund: "REFUND"
    },

    // Table headers
    table: {
      description: "Description",
      quantity: "Quantity",
      itemPrice: "Item Price",
      totalPrice: "Total Price"
    },

    // Information section
    information: "INFORMATION:",
    extraServices: "Extra Services:",

    // Summary section
    summary: {
      subTotal: "Sub Total",
      merchantDelivery: "Merchant Delivery",
      serviceCharges: "Service Charges",
      discount: "Discount",
      extraServices: "Extra Services",
      totalPrice: "Total Price",
      totalPaid: "Total Paid",
      remaining: "Remaining",
      dueAmount: "Due Amount"
    },

    // Footer
    footer: {
      printedBy: "Printed By:",
      printedOn: "Printed On:",
      admin: "Admin",
      contactMessage: "If you have any questions about this invoice, please contact",
      contactInfo: "9ar Store +964 7866601010, info@9arstore.com",
      thankYou: "Thank You For Your Business!"
    },

    // Print button
    printButton: "Print / Download PDF"
  },

  buttons: {
    submit: "Submit",
    update: "Update",
    submitting: "Submitting...",
    updating: "Updating...",
    backToIndex: "Back to Index"
  },
  
  breadcrumbs: {
    invoices: "Invoices",
    create: "Create Invoice",
    edit: "Edit Invoice",
    view: "View Invoice"
  }
};
